<input type="hidden" id="CurPageNo" value="{{ this.pageNumber + 1 }}" />
<div (window:beforeunload)="onBeforeUnload()"></div>

<div id="mainLoader" class="mainLoader" *ngIf="showLoader">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle === 'K12 Insight'"></div>
  </div>
</div>

<div
  *ngIf="maxPageNumber > 0"
  [ngClass]="
    !isRemoveBackGround
      ? surveyData?.SurveyDetails.isSystemBGImage ||
        surveyData?.SurveySettings.SurveyBackgroundImage
        ? surveyBackground
        : ''
      : ''
  "
  class="{{ surveyData?.SurveySettings.SurveytemplateName }} pg-radius"
></div>

<form
  *ngIf="maxPageNumber > 0"
  id="surveyFrom"
  name="form"
  #f="ngForm"
  (keydown.enter)="preventEvent($event)"
  (ngSubmit)="GetNextPage(pageNumber, false)"
  autocomplete="off"
  [ngClass]="{
    'mobile-wrapper': isMobile,
    'tablet-wrapper': isTablet,
    'preview-bg-color': isPreview,
    verticalSpacing: true,
    isTopBarSticky: surveyData?.SurveyDetails.isProgress === 4 && maxPageNumber > 1
  }"
  novalidate
>
  <div class="bg-overlay"></div>

  <!-- 107124 -->
  <div class="test-strip" *ngIf="surveyData?.SurveyDetails.isTest">
    <span style="font-weight: bold">{{ surveyData?.SurveyMessages.strWarning }} </span
    >{{ surveyData?.SurveyMessages.TestWarningMsg }}
  </div>

  <div class="pm-modal-overlay timeout-modal-overlay" style="display: none">
    <div class="fbcNewmodalDialog" style="width: 500px">
      <div class="fbcNewmodalHeader Alert">
        <div class="fbcNewmodalTitle">Time Out</div>
      </div>
      <div class="fbcNewmodalBody">
        <div>{{ timeouttext }}</div>
      </div>
      <div class="fbcNewmodalFooter" style="padding-left: 60px">
        <input
          type="button"
          name="btncontinue"
          value="Ok"
          class="button ok-btn"
          style="padding: 5px 25px"
          (click)="timeCounterAlert1()"
        />
      </div>
    </div>
  </div>

  <div class="pm-modal-overlay ansclear-modal-overlay" style="display: none">
    <div class="fbcNewmodalDialog" style="width: 500px">
      <div class="fbcNewmodalHeader Alert">
        <div class="fbcNewmodalTitle">Clear Answers</div>
        <div class="fbcNewmodalClose" (click)="closeansclearModal(0)"></div>
      </div>
      <div class="fbcNewmodalBody">
        <div>{{ surveyData?.SurveyMessages.AreUsureClear }}</div>
      </div>
      <div class="fbcNewmodalFooter" style="padding-left: 60px">
        <input
          type="button"
          name="btncontinue"
          value="Cancel"
          class="button cancel-btn"
          style="padding: 5px 25px"
          (click)="closeansclearModal(0)"
        />
        <input
          type="button"
          name="btncontinue"
          value="Okay"
          class="button ok-btn"
          style="padding: 5px 22px"
          (click)="closeansclearModal(1)"
        />
      </div>
    </div>
  </div>

  <div class="pm-modal-overlay test-modal-overlay" style="display: none">
    <div class="fbcNewmodalDialog" style="width: 500px">
      <div class="fbcNewmodalHeader Alert">
        <div class="fbcNewmodalTitle">{{ surveyData?.SurveyMessages.TestHeader }}</div>
      </div>
      <div class="fbcNewmodalBody">
        <div>{{ surveyData?.SurveyMessages.TestWarningMsg }}</div>
      </div>
      <div class="fbcNewmodalFooter" style="padding-left: 60px">
        <input
          type="button"
          name="btncontinue"
          value="{{ surveyData?.SurveyMessages.TestGotIt }}"
          class="button ok-btn"
          style="padding: 5px 25px"
          (click)="closeTestModal()"
        />
      </div>
    </div>
  </div>
  <!-- 107124 ends -->

  <div
    *ngIf="surveyData?.SurveyDetails.isShowPartial"
    class="see-more-container"
    id="dvSeeMoreContainer"
    runat="server"
  >
    <div class="see-more-overlay"></div>
    <div class="see-more-webview">Click here to participate</div>
  </div>
  <div
    *ngIf="multiLanguage"
    class="languageWrapper"
    [ngClass]="{
      embedLangs:
        surveyData?.SurveyDetails.intSourceID === 6 || surveyData?.SurveyDetails.surveytype === 6
    }"
  >
    <div
      class="languageCont"
      [ngClass]="{ highLang: surveyData?.LanguageDatas.length > 10 && !isLoading }"
    >
      <div class="languageHeader" id="dvlanguageHeader">
        <div class="languageTitle">Please select a language to proceed</div>
      </div>
      <div class="languageBody">
        <div class="langModal" tabindex="-1">
          <div
            *ngFor="let lang of surveyData?.LanguageDatas"
            class="language"
            [ngClass]="
              selectedLang == lang.LangID ||
              (selectedLang == 0 &&
                surveyData.SurveySettings.primary_lang_id != 0 &&
                surveyData.SurveySettings.primary_lang_id == lang.LangID)
                ? 'sel-lang'
                : ''
            "
          >
            <a
              href="javascript:void(0);"
              (click)="GetLanguageId(lang)"
              [ngStyle]="{
                'pointer-events':
                  this.preview?.isPagePreview && selectedLang != lang.LangID ? 'none' : 'all'
              }"
            >
              <span>{{ lang.LanguageName.trim() }}</span>
              <span id="arabicLabel" class="visually-hidden">{{ lang.Name.trim() }}</span>
            </a>
          </div>
        </div>
        <span
          *ngIf="!isLoading"
          id="alangCancel"
          (click)="CancelLanguage()"
          href="javascript:void(0);"
          class="lang-close-modal"
        ></span>
      </div>
    </div>
  </div>

  <div
    *ngIf="isTimeOutMsg || isTimeOutMsg_2"
    class="pm-modal-overlay timeOutMsgWrapper"
    (keydown)="trapFocus($event)"
  >
    <div
      class="fbcNewmodalDialog"
      [ngStyle]="{ 'min-height': isTimeOutMsg ? '161px' : '' }"
      style="width: 500px"
    >
      <div class="fbcNewmodalBody" [ngStyle]="{ 'min-height': isTimeOutMsg ? '110px' : '' }">
        <span *ngIf="isTimeOutMsg">
          <span style="font-weight: bold">{{ surveyData?.SurveyMessages.strWarning }} </span>
          {{ surveyData?.SurveyMessages.SurveyTimeOutWarning1 }}</span
        >
        <span *ngIf="isTimeOutMsg_2">{{ surveyData?.SurveyMessages.SurveyTimeOutWarning2 }}</span>
      </div>
      <div *ngIf="isTimeOutMsg" class="fbcNewmodalFooter" style="padding-left: 60px">
        <input
          type="button"
          name="btncontinue"
          value="{{ surveyData?.SurveyMessages.strOk }}"
          class="button ok-btn"
          style="padding: 5px 25px"
          (click)="ActiveSurvey()"
        />
      </div>
    </div>
  </div>

  <!-- 111394: [CRT] "Accept cookies" should be shown on participation for EU countries -->
  <div *ngIf="isAcceptCookies" class="cookie-container">
    <div class="cookie-strip1">
      <div class="cookie-image"></div>
      <div class="cookie-text-cont">
        <span class="cookie-main-text"
          ><strong>{{ surveyData?.SurveyMessages.AcceptCookieHeader }}</strong></span
        ><br />
        <span class="cookie-sub-text"
          >{{ splitAcceptCookieMessage(0) }}
          <span class="manage-preference" (click)="showPreferences()">{{
            surveyData?.SurveyMessages.strManagePreference
          }}</span>
          {{ splitAcceptCookieMessage(1) }}
        </span>
      </div>
      <a
        href="javascript:void(0);"
        (click)="acceptCookies()"
        style="text-decoration: none; min-width: 150px"
      >
        <span class="acceptCookieBtn">{{ surveyData?.SurveyMessages.AcceptCookieButton }}</span>
      </a>
    </div>

    <div class="manage-cont">
      <div class="manage-header">
        <div class="cookie-image"></div>
        <div class="cookie-text-cont">
          <span class="cookie-main-text"
            ><strong>{{ surveyData?.SurveyMessages.AcceptCookieHeader }}</strong></span
          ><br />
          <span class="cookie-sub-text">{{ surveyData?.SurveyMessages.strChooseCookies }} </span>
        </div>
      </div>
      <div class="manage-body">
        <div class="flex-body">
          <div class="toggle-container">
            <label class="toggle-body active functional-toggle" (click)="showFunctionalTooltip()">
              <div class="cd-tooltip">
                {{ surveyData?.SurveyMessages.strConsentSmoothParticipation }}
              </div>
            </label>
          </div>
          <div class="cookie-details">
            <div>
              <span class="cd-title">{{ surveyData?.SurveyMessages.strFuctionalCookies }}</span>
              <span class="blue-muted-text">{{ surveyData?.SurveyMessages.strAlwaysActive }}</span>
            </div>
            <div class="cd-text">
              {{ surveyData?.SurveyMessages.strConsentSmoothParticipation }}
            </div>
            <ul class="cd-list">
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentChooseLanguage }}
              </li>
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentBrowserSupport }}
              </li>
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentMaintainSession }}
              </li>
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentTracksStatus }}
              </li>
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentRestrictedParticipation }}
              </li>
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentDownloadCookie }}
              </li>
              <li class="cd-list-item">{{ surveyData?.SurveyMessages.strConsentCookie }}</li>
            </ul>
          </div>
        </div>
        <div class="flex-body" style="margin-top: 20px">
          <div class="toggle-container">
            <input type="checkbox" id="analytics" class="cookie-toggle" />
            <label class="toggle-body" for="analytics" aria-label="Enable Analytics"></label>
          </div>
          <div class="cookie-details">
            <div>
              <span class="cd-title">{{ surveyData?.SurveyMessages.strAnalyticsCookies }} </span>
            </div>
            <div class="cd-text">{{ surveyData?.SurveyMessages.strAnalyticsCookiesGoogle }}</div>
            <ul class="cd-list">
              <li class="cd-list-item">
                {{ surveyData?.SurveyMessages.strConsentGoogleAnalytics }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="manage-footer clearfix">
        <span class="acceptChoiceBtn fr" (click)="hidePreference()">{{
          surveyData?.SurveyMessages.strAcceptCookieChoices
        }}</span>
        <span class="cancel-btn fr" (click)="cancelPreference()">{{
          surveyData?.SurveyMessages.strCookieCancle
        }}</span>
      </div>
    </div>
  </div>

  <button
    class="hamburger hamburger--slider"
    type="button"
    *ngIf="
      isMobile &&
      !isThankYouPage &&
      !isSaveAndContinue &&
      !isHideHambugforEmbedMob &&
      !commonSetting.isEmbedPopWeb &&
      !isOfflinePage &&
      (surveyData?.SurveySettings.IsAnonymous ||
        surveyData?.SurveySettings.isclearanswers ||
        isPrintDownload ||
        surveyData?.SurveySettings.IsEditLater ||
        surveyData?.LanguageDatas.length > 1)
    "
    (click)="showHamburgerMenu()"
    [ngClass]="{
      beta: !(surveyData.CorpSettings.isAngularSurvey || surveyData.SurveySettings.isAngularSurvey)
    }"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </button>

  <div class="anonymous-msg-wrap" *ngIf="isMobile">
    <div class="anonymous-msg">
      <div
        style="max-height: 400px; overflow: auto"
        [innerHTML]="surveyData.SurveyMessages.AnonymousMessageMobile | headerFooterHtml"
      ></div>
      <div class="anonymous-msg-btn" (click)="hideAnonymousPopup()">
        {{ surveyData?.SurveyMessages.strOk }}
      </div>
    </div>
  </div>

  <div
    class="countdown-timer"
    *ngIf="
      surveyData?.SurveySettings.IsShowTimerOnParticipation &&
      !isThankYouPage &&
      !isSaveAndContinue &&
      !isAcceptCookies
    "
    role="timer"
    tabindex="0"
    [ngClass]="{
      beta: !(surveyData.CorpSettings.isAngularSurvey || surveyData.SurveySettings.isAngularSurvey)
    }"
  >
    <span>{{ currentValue }}</span>
  </div>

  <div
    *ngIf="
      ((surveyData?.LanguageDatas.length > 1 &&
        !multiLanguage &&
        (pageNumber == 0 || AllQuestionHideONPrevPages(pageNumber)) &&
        !surveyData?.SurveyDetails.isSurveyReopened) ||
        isPrintDownload ||
        ((surveyData?.SurveySettings.IsEditLater ||
          surveyData?.SurveySettings.isclearanswers ||
          surveyData?.SurveySettings.IsAnonymous) &&
          isMobile)) &&
      (!isThankYouPage || isMobile) &&
      !isHideEmbedWebHeader
    "
    class="clearfix header-div"
    [ngClass]="{ 'hamburger-menu': isMobile }"
  >
    <div
      *ngIf="!isThankYouPage"
      class="clearfix"
      [ngClass]="{
        'hamburger-margin': isMobile,
        beta: !(
          surveyData.CorpSettings.isAngularSurvey || surveyData.SurveySettings.isAngularSurvey
        )
      }"
    >
      <div
        *ngIf="isPrintDownload && !isMobile && !this.isOfflineSurvey"
        [ngClass]="this.preview.isPagePreview ? 'page-preview' : ''"
      >
        <a
          id="print_survey"
          title="{{ surveyData?.SurveyMessages.PrintBlankSurvey }}"
          target="_self"
          class="print-survey-wrapper float-r"
          (click)="startFileDownload(); openExport()"
          href="javascript:void(0);"
        >
        </a>
      </div>

      <ng-container *ngIf="isMobile; else WebLang">
        <div
          (click)="GetLanguageDetails()"
          *ngIf="
            surveyData?.LanguageDatas.length > 1 &&
            !multiLanguage &&
            (pageNumber == 0 || AllQuestionHideONPrevPages(pageNumber)) &&
            !isEditedResponse
          "
          class="select-language-wrap"
          [ngClass]="{ 'float-r': !isMobile }"
        >
          <a
            (click)="GetLanguageDetails()"
            class="selected-lang-name"
            style="font-family: montserrat, sans-serif !important"
            tabindex="1"
            href="javascript:void(0);"
            >{{ selectedLanguageName }}</a
          >
        </div>
      </ng-container>
      <ng-template #WebLang>
        <div
          (click)="GetLanguageDetails()"
          *ngIf="
            surveyData?.LanguageDatas.length > 1 &&
            !multiLanguage &&
            (pageNumber == 0 || AllQuestionHideONPrevPages(pageNumber)) &&
            !isEditedResponse
          "
          class="select-language-wrap"
          [attr.title]="surveyData?.SurveyMessages.Participation_ChooseLanguage"
          [ngClass]="{ 'float-r': !isMobile }"
        >
          <a
            (click)="GetLanguageDetails()"
            class="selected-lang-name"
            style="font-family: montserrat, sans-serif !important"
            tabindex="1"
            href="javascript:void(0);"
          ></a>
        </div>
      </ng-template>

      <div
        *ngIf="isMobile && surveyData?.SurveySettings.IsEditLater && !this.isOfflineSurvey"
        class="save-answer-div"
        (click)="SaveAndContinue(pageNumber); showHamburgerMenu()"
        [ngClass]="{
          'page-preview': this.preview.isPagePreview,
          disabled: isSaveAndContinueDisabled
        }"
      >
        {{ surveyData?.SurveyMessages.SaveContinueLater }}
      </div>

      <div
        *ngIf="isPrintDownload && isMobile && !this.isOfflineSurvey"
        class="print-survey-div"
        [ngClass]="this.preview.isPagePreview ? 'page-preview' : ''"
      >
        <a id="print_survey" target="_self" (click)="startFileDownload(); openExport()">
          {{ surveyData?.SurveyMessages.PrintBlankSurvey }}
        </a>
      </div>

      <div
        *ngIf="isMobile && surveyData?.SurveySettings.isclearanswers"
        class="clear-answer-div"
        (click)="showHamburgerMenu(); ResetPage1(pageNumber)"
        [ngClass]="this.preview.isPagePreview ? 'page-preview' : ''"
      >
        {{ surveyData?.SurveyMessages.ClearAllAnswers }}
      </div>
    </div>

    <!-- Anonymous Header For Mobile -->
    <div
      class="anonymous-btn"
      *ngIf="isMobile && surveyData?.SurveySettings.IsAnonymous"
      (click)="showAnonymousPopup()"
      [innerHTML]="surveyData?.SurveyMessages.MobileAnonymousHdr | headerFooterHtml"
      [ngClass]="{
        'page-preview': this.preview.isPagePreview,
        beta: !(
          surveyData.CorpSettings.isAngularSurvey || surveyData.SurveySettings.isAngularSurvey
        )
      }"
    ></div>

    <div *ngIf="surveyData?.SurveyDetails.isShowTimeOut && isMobile" class="mobile-timeout">
      {{ surveyData?.SurveyMessages.SurveyTimeOutMessage }}
    </div>
  </div>

  <div
    [hidden]="!selectedLanguage"
    [ngClass]="[
      isRTL ? 'RTLDir' : '',
      multiLanguage && isPreview ? 'languaModeOpen' : '',
      isMobile &&
      !isThankYouPage &&
      !isSaveAndContinue &&
      !isHideHambugforEmbedMob &&
      !commonSetting.isEmbedPopWeb &&
      !isOfflinePage &&
      (surveyData?.SurveySettings.IsAnonymous ||
        surveyData?.SurveySettings.isclearanswers ||
        isPrintDownload ||
        surveyData?.SurveySettings.IsEditLater ||
        surveyData?.LanguageDatas.length > 1)
        ? 'mobile-wrapper-padding'
        : ''
    ]"
  >
    <div
      *ngIf="isNewParticipation && surveyFormat == 2"
      [ngStyle]="{ height: headerFooterSpacer() ? '5px' : '' }"
      ngClass="header-spacer"
    ></div>
    <div
      [ngClass]="
        surveyData?.SurveySettings.surveyWidthType == 3 || isTablet
          ? 'full-survey-width '
          : surveyData?.SurveySettings.surveyWidthType == 2
            ? 'medium-survey-width'
            : surveyData?.SurveySettings.surveyWidthType == 1
              ? 'small-survey-width'
              : ''
      "
      class="surveyWidth survey-border"
      id="surveyWidth-main"
    >
      <ng-container *ngIf="surveyData?.SurveyDetails.isProgress === 4">
        <div
          class="progress-bar-wrapper"
          id="topProgessBarSticky"
          [ngClass]="{ 'mobile-progress-bar': isMobile }"
          *ngIf="
            maxPageNumber > 1 &&
            getDisplayPageCount(pageNumber) > 1 &&
            surveyData?.SurveyDetails.isProgress == 4 &&
            !isOfflinePage
          "
        >
          <app-progressbar [PercentValue]="GetPercentage()"></app-progressbar>
          <div
            class="clsPageNo"
            *ngIf="
              surveyData?.SurveySettings.displaypagenumber && getDisplayPageCount(pageNumber) > 1
            "
          >
            <span>
              <!-- Page {{pageNumber + 1}} of {{maxPageNumber}} -->
              {{ surveyData?.SurveyMessages.page }} {{ getDisplayPageNo(pageNumber) }}
              {{ surveyData?.SurveyMessages.of1 }} {{ getDisplayPageCount(pageNumber) }}
            </span>
          </div>
        </div>
      </ng-container>
      <div
        class="progress-bar-wrapper progress-bar-wrapper-footer"
        *ngIf="
          maxPageNumber > 1 &&
          getDisplayPageCount(pageNumber) > 1 &&
          (surveyData?.SurveyDetails.isProgress == 2 ||
            surveyData?.SurveyDetails.isProgress == 3) &&
          !isMobile
        "
      >
        <app-progressbar
          *ngIf="surveyData?.SurveyDetails.isProgress !== 4"
          [PercentValue]="GetPercentage()"
        ></app-progressbar>

        <div
          class="clsPageNo"
          *ngIf="
            surveyData?.SurveySettings.displaypagenumber && getDisplayPageCount(pageNumber) > 1
          "
        >
          <span>
            {{ surveyData?.SurveyMessages.page }} {{ getDisplayPageNo(pageNumber) }}
            {{ surveyData?.SurveyMessages.of1 }} {{ getDisplayPageCount(pageNumber) }}
          </span>
        </div>
      </div>

      <div
        *ngIf="isNewParticipation && surveyFormat == 3"
        class="ques-arrow back-arrow disabled"
        (click)="showPrevQues()"
      ></div>
      <div
        *ngIf="isNewParticipation && surveyFormat == 3"
        class="ques-arrow next-arrow"
        (click)="showNextQues()"
      ></div>

      <div *ngIf="surveyData?.SurveySettings.SurveyLogoImageUrl" class="survey-logo">
        <div
          [ngClass]="
            surveyData?.SurveySettings.SurveyLogoAlign == 1
              ? 'align-l'
              : surveyData?.SurveySettings.SurveyLogoAlign == 2
                ? 'align-c'
                : surveyData?.SurveySettings.SurveyLogoAlign == 3
                  ? 'align-r'
                  : ''
          "
        >
          <app-image-control
            [imageName]="surveyData?.SurveySettings.SurveyLogoImageUrl"
            [imagePath]="undefined"
            [imageRedirectURL]="undefined"
            [imageCaption]="
              surveyData?.SurveyDetails.SurveyLogoCaption
                ? surveyData?.SurveyDetails.SurveyLogoCaption
                : undefined
            "
          >
          </app-image-control>
        </div>
      </div>

      <div
        *ngIf="surveyData?.SurveySettings.SurveyHeader"
        [ngClass]="
          surveyData?.SurveySettings.isOverAllStyleAppliedToHeader
            ? 'survey-header'
            : 'survey-header-nb'
        "
      >
        <app-header [headerString]="surveyData?.SurveySettings.SurveyHeader"></app-header>
      </div>

      <div class="questions-wrapper" id="questionWrapper" role="main"  [ngClass]="{ 'animation-wrapper': isTransitionEnabled }">
        <div
          *ngIf="
            !isAllQuestionHideMessage &&
            isMandatory &&
            !isSubmittedForm &&
            surveyData?.SurveySettings.isMandatoryUpfront
          "
          class="mndtry-txt-clr"
        >
          <span class="icon__mandatory" aria-label="Mandatory field"></span>
          <span aria-live="polite" role="alert">{{ surveyData?.SurveyMessages.requiredInfo }}</span>
        </div>

        <div
          [ngClass]="{
            'new-participation-focus': isNewParticipation && surveyFormat == 1,
            'new-participation-v': isNewParticipation
          }"
        >
          <div *ngIf="pageNumber != 999 && pageNumber < maxPageNumber && !isOfflinePage && surveyData?.Pages?.[pageNumber]?.Questions?.length > 0">
            <div *ngIf="isAllQuestionHideMessage" class="hidden-message">
              Question(s) are hidden due to logic or data population settings.
            </div>
            <div
              class="main-ques-cont"
              [ngClass]="{
                'active-ques': questions.isFirstShowQuestion && isNewParticipation,
                'inactive-ques': !questions.isFirstShowQuestion && isNewParticipation
              }"
              *ngFor="
                let questions of surveyData?.Pages[pageNumber].Questions;
                let j = index;
                trackBy: trackByUniqueNumber
              "
              (keyup.tab)="focusOnQuestion($event.target)"
              (keyup.shift.tab)="focusOnQuestion($event.target)"
            >
              <div
                id="dv_main_{{ questions?.UniqueNumber }}"
                [ngClass]="
                  (questions.qtype != 'RK' &&
                    questions.qtype != 'T' &&
                    (questions.qsubtype != 1 ||
                      questions.qsubtype != 2 ||
                      questions.qsubtype != 3 ||
                      questions.qsubtype != 4)) ||
                  (questions.qtype == 'T' &&
                    (questions.qsubtype == 71 ||
                      questions.qsubtype == 0 ||
                      questions.qsubtype == 21 ||
                      questions.qsubtype == 31 ||
                      questions.qsubtype == 41 ||
                      questions.qsubtype == 22 ||
                      questions.qsubtype == 61 ||
                      questions.qsubtype == 21 ||
                      questions.qsubtype == 51 ||
                      questions.qsubtype == 11 ||
                      questions.qsubtype == 12 ||
                      questions.qsubtype == 10) &&
                    questions.qtype != 'RW' &&
                    questions.qsubtype != 3)
                    ? 'divScroll'
                    : ''
                "
                *ngIf="
                  (questions.population_type != 2 &&
                    questions.population_type != 5 &&
                    !isHiddenQuestion(questions) &&
                    !questions.IsOfflineSkipQuestion &&
                    !questions.isDirectoryHidden &&
                    !(questions.AnsPipeQID > 0 && questions.Answers.length == 0) &&
                    DrillDownHide(questions, pageNumber)) ||
                  isShowHiddenQN
                "
              >
                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) ||
                    allAnswersADLHide(questions, pageNumber, false)
                  "
                  *ngIf="
                    (f.submitted &&
                      questions.AnswerText == null &&
                      !allAnswersADLHide(questions, pageNumber, false) &&
                      questions.isSoftRequired &&
                      !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                      nextButtonClickNo <= 1 &&
                      !isCapchaManditorySkip) ||
                    (f.submitted &&
                      questions.isSQ &&
                      CheckInlineQuestion(questions, pageNumber) &&
                      !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                      nextButtonClickNo <= 1 &&
                      !isCapchaManditorySkip)
                  "
                  class="soft-req-msg"
                >
                  {{ questions.SoftReqErrorMsg }}
                </div>

                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) ||
                    allAnswersADLHide(questions, pageNumber, false)
                  "
                  *ngIf="
                    f.submitted &&
                    ((questions.mandatory &&
                      !allAnswersADLHide(questions, pageNumber, false) &&
                      questions.group_no == 0 &&
                      (questions.AnswerText == null ||
                        ((questions.qtype == 'R' ||
                          questions.qtype == 'C' ||
                          questions.qtype == 'L' ||
                          questions.qtype == 'ML' ||
                          questions.qtype == 'HR') &&
                          questions.isOtherAnswer &&
                          questions.otherAnswer == null)) &&
                      questions.qtype != 'CM') ||
                      (questions.isMultiControlValid && !questions.isMultiQuestion) ||
                      (questions.AnswerText == null &&
                        questions.mandatory &&
                        !questions.IsDisabled &&
                        questions.group_no > 0 &&
                        !questions.isMultiQuestion &&
                        questions.isMatrixQuestion)) &&
                    !isCapchaManditorySkip
                  "
                  class="mndtry-txt-clr"
                >
                  <div
                    [innerHTML]="surveyData?.SurveyMessages.AsteriskMandatory | headerFooterHtml"
                  ></div>
                </div>

                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) ||
                    allAnswersADLHide(questions, pageNumber, false)
                  "
                  *ngIf="commonLogic.isAllQuestionAnswersExausts(questions)"
                  class="quota-ex-msg"
                >
                  {{ surveyData?.SurveyMessages.QuotaExaustMsg }}
                </div>

                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) ||
                    allAnswersADLHide(questions, pageNumber, false)
                  "
                  *ngIf="
                    questions.isGoBackQuota && !commonLogic.isAllQuestionAnswersExausts(questions)
                  "
                  class="quota-ex-msg"
                >
                  {{ surveyData?.SurveyMessages.ParticipationQuotaExaust }}
                </div>

                <div
                  class="first-div"
                  style="height: 1px; width: 1px; opacity: 0"
                  [hidden]="j != 0"
                ></div>
                <app-question-spacer
                  id="dv_spacer_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    !(this.isOfflineSurvey && questions.qtype === 'T' && (questions.qsubtype === 1 || questions.qsubtype === 71 || questions.qsubtype === 72)) &&
                    !questions.isMultiQuestion &&
                    shouldShowSpacerForQuestion(questions) &&
                    questions.population_type != 2 &&
                    questions.population_type != 5 &&
                    !questions.isDirectoryHidden &&
                    !isHiddenQuestion(questions) &&
                    !(questions.AnsPipeQID > 0 && questions.Answers.length == 0) &&
                    DrillDownHide(questions, pageNumber)
                  "
                  [BottomPosition]="false"
                  [questionSpacer]="questionSpacerHeight"
                  class="top-question-spacer"
                  #topquestionspacer
                ></app-question-spacer>
                <!-- Matrix Grid --><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions?.isGroupCQHide && questions?.isNOGroupRule) ||
                      (questions?.isGroupRule && questions?.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    (questions.qtype == 'GR' ||
                      questions.qtype == 'SR' ||
                      questions.qtype == 'GC' ||
                      (questions.qtype == 'T' && !GetIsMulti(GetGroupData(questions.group_no))) ||
                      questions.qtype == 'GD' ||
                      questions.qtype == 'RG' ||
                      questions.qtype == 'RW' ||
                      questions.qtype == 'SC') &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.isMatrixQuestion
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  "
                >
                  <app-matrix-grid
                    [JsonData]="GetMatrixGridQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [groups]="questions | getgroup | getmatrix | getmatrixgroup"
                    [matrix]="questions | getgroup | getmatrix"
                    [isSubmitted]="isSubmittedForm"
                    [isMobile]="isMobile"
                    [DropDown]="surveyData?.SurveyMessages.DropDown"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-matrix-grid>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- demographics --><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.DemographicFieldID != 0 && !questions.isMultiQuestion"
                  class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  "
                >
                  <app-demographics
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMobile]="isMobile"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroup"
                    [MonthArray]="surveyData?.SurveyMessages.strMonthArray"
                    [DropDown]="surveyData?.SurveyMessages.DropDown"
                    [isNewParticipationButton]="true"
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-demographics>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Multiple Text Box -->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    questions.qtype == 'T' &&
                    GetIsMulti(GetGroupData(questions.group_no)) &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          questions.qsubtype == 72 &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-multiple-text-box
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isSubmitted]="isSubmittedForm"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    [group]="questions | getgroup"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    [matrix]="questions | getgroup | getmatrix"
                    [isSignatureControl]="questions.qsubtype == 72 ? true : false"
                  >
                  </app-multiple-text-box>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Multiple Drop Down--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    questions.qtype == 'RW' &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.qsubtype != 3 &&
                    questions.qsubtype != 1 &&
                    !questions.isMatrixQuestion
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.isMultiControlValid &&
                    GetIsMulti(GetGroupData(questions.group_no)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  "
                >
                  <app-multiple-drop-down
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMobile]="isMobile"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroup"
                    [isMDD]="questions | getgroup | ismulti"
                    [matrix]="questions | getgroup | getmatrix"
                    [isSubmitted]="isSubmittedForm"
                    [DropDown]="surveyData?.SurveyMessages.DropDown"
                    [isNewParticipationButton]="true"
                    [productTitle]="productTitle"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-multiple-drop-down>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- drill Down--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    questions.qtype == 'RW' &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.qsubtype == 3 &&
                    !questions.isMatrixQuestion
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  "
                >
                  <app-drill-down
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMobile]="isMobile"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroup"
                    [matrix]="questions | getgroup | getmatrix"
                    [isShowHiddenQN]="isShowHiddenQN"
                    [DropDown]="surveyData?.SurveyMessages.DropDown"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-drill-down>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Grid Questions--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    (questions.qtype == 'GR' ||
                      questions.qtype == 'SR' ||
                      questions.qtype == 'GC' ||
                      questions.qtype == 'SC' ||
                      questions.qtype == 'RG' ||
                      (questions.qtype == 'RW' && questions.qsubtype == 1)) &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    !questions.isMatrixQuestion
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    !isMobile &&
                    (questions.qtype == 'SR' || questions.qtype == 'SC') &&
                    questions.isMultiControlValid &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  "
                >
                  <app-grid-questions
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroup"
                    [isSubmitted]="isSubmittedForm"
                    [matrix]="questions | getgroup | getmatrix"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-grid-questions>
                  <div
                    class="ques-overlay"
                    *ngIf="
                      isNewParticipation &&
                      (surveyFormat == 1 || surveyFormat == 2 || surveyFormat == 2)
                    "
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Symbol rating scale -->
                
                <div
                  id="dv_{{ questions?.UniqueNumber }}"
                  [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'GQ' && !questions.isMultiQuestion"
                  class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-symbol-rating-scale
                    [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isDisplaySubQno]="false"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    [group]="questions | getgroup"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-symbol-rating-scale>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Radio Button -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    ((!questions.isCQHide && questions.qtype == 'R' && questions.qsubtype != 2) ||
                      questions.qtype == 'HR' ||
                      (questions.qtype == 'RT' && questions.qsubtype == 7)) &&
                    !allAnswersADLHide(questions, pageNumber, false)
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : (f.submitted &&
                            questions.isSoftRequired &&
                            questions.AnswerText == null &&
                            !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip) ||
                          (f.submitted &&
                            questions.isSQ &&
                            !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip &&
                            CheckInlineQuestion(questions, pageNumber))
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-radio-button
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-radio-button>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Thumbs Up -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'R' && questions.qsubtype == 2"
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-thumbs-up
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-thumbs-up>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Check Box -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    ((!questions.isCQHide && questions.qtype == 'C') || questions.qtype == 'ML') &&
                    !allAnswersADLHide(questions, pageNumber, false)
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : (f.submitted &&
                            questions.isSoftRequired &&
                            questions.AnswerText == null &&
                            !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip) ||
                          (f.submitted &&
                            questions.isSQ &&
                            !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip &&
                            CheckInlineQuestion(questions, pageNumber))
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-check-box
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-check-box>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Text Box -->
                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) || (questions.isSQ && questions.isCQHide)
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'T' && questions.group_no == 0"
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.AnswerText == null &&
                          questions.isSoftRequired &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-text-box
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isDisplaySubQno]="false"
                    [MonthArray]="surveyData?.SurveyMessages.strMonthArray"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isMTB]="false"
                    [isDemographics]="false"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-text-box>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- descriptive-text -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  *ngIf="
                    questions.qtype == 'CM' &&
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    questions.qsubtype == 1
                  "
                >
                  <p class="capcha-error">{{ questions.error_msg }}</p>
                </div>
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'CM'"
                  class="question-data comment-question-type"
                  [ngClass]="
                    questions.qtype == 'CM' &&
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    questions.qsubtype == 1
                      ? 'mandatorycapcha'
                      : f.submitted && questions.mandatory && questions.AnswerText == null
                        ? 'mandatory'
                        : ''
                  "
                >
                  <app-descriptive-text
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMobile]="isMobile"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isNewParticipationButton]="true"
                    [isDarkTheme]="isCapchaDarkTheme"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)"
                  >
                  </app-descriptive-text>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Ranking -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    !questions.isCQHide &&
                    questions.qtype == 'RK' &&
                    !allAnswersADLHide(questions, pageNumber, false)
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.AnswerText != null && questions.selectedOptionList.length == 0)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-ranking
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [Rank]="surveyData?.SurveyMessages.Rank"
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-ranking>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Drop Down -->
                <div
                  [hidden]="
                    (questions.isCQ && questions.isCQHide) || (questions.isSQ && questions.isCQHide)
                  "
                  id="dv_{{ questions?.UniqueNumber }}"
                  class="question-data"
                  *ngIf="
                    (questions.qtype == 'L' ||
                      (questions.qtype == 'RT' && questions.qsubtype == 0)) &&
                    !allAnswersADLHide(questions, pageNumber, false) &&
                    questions.group_no == 0 &&
                    !(
                      (questions.isCQ && questions.isCQHide) ||
                      (questions.isSQ && questions.isCQHide)
                    )
                  "
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerID == 0 ||
                      questions.AnswerID == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-drop-down
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isDisplaySubQno]="false"
                    [isMDD]="false"
                    [isNonSearchable]="false"
                    [DropDown]="surveyData?.SurveyMessages.DropDown"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-drop-down>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Rating Scale -->
                <div
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'RS' && !(questions.isCQ && questions.isCQHide)"
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-rating-scale
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-rating-scale>
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>

                <!-- Numeric Allocation -->
                <div
                  [hidden]="questions.isCQ && questions.isCQHide"
                  id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="
                    !questions.isCQHide &&
                    questions.qtype == 'CS' &&
                    !allAnswersADLHide(questions, pageNumber, false)
                  "
                  class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          !surveyData?.Pages[pageNumber].isSoftRequiredHandle &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  "
                >
                  <app-numeric-allocation
                    [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="surveyData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="surveyData?.SurveySettings.isMandatoryUpfront"
                    [isMobile]="isMobile"
                    [isNewParticipationButton]="true"
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                  >
                  </app-numeric-allocation>

                  <!-- New Participation Fade Overlay -->
                  <div
                    class="ques-overlay"
                    *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)"
                    (mouseover)="activateQuestionOnHover($event.target)"
                    (click)="getQuestionInView($event.target)"
                  ></div>
                </div>
              </div>

              <!-- Question Spacer handled here -->
              <app-question-spacer
                *ngIf="
                  !(this.isOfflineSurvey && questions.qtype === 'T' && (questions.qsubtype === 1 || questions.qsubtype === 71 || questions.qsubtype === 72)) &&
                  !questions.isMultiQuestion &&
                  shouldShowSpacerForQuestion(questions) &&
                  !allAnswersADLHide(questions, pageNumber, false) &&
                  ((questions.population_type != 2 &&
                    questions.population_type != 5 &&
                    !isHiddenQuestion(questions)) ||
                    preview?.isShowHiddenQN) &&
                  !questions.isDirectoryHidden &&
                  !(questions.AnsPipeQID > 0 && questions.Answers.length == 0) &&
                  DrillDownHide(questions, pageNumber) &&
                  removeQuestionSpacerForPiping(questions)
                "
                [BottomPosition]="true"
                [questionSpacer]="questionSpacerHeight"
              >
              </app-question-spacer>

              <div *ngIf="!isDivScroll">{{ addDivScroll(j) }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="isMobile" class="mobile-scroll"></div>
      </div>

      <div
        *ngIf="surveyData?.SurveySettings.SurveyFooter"
        [ngClass]="{
          'new-participation-focus': isNewParticipation && surveyFormat == 1,
          'new-participation-v': isNewParticipation,
          'survey-footer': surveyData?.SurveySettings.isOverAllStyleAppliedToFooter,
          'survey-footer-nb': !surveyData?.SurveySettings.isOverAllStyleAppliedToFooter
        }"
      >
        <app-footer [footerString]="surveyData?.SurveySettings.SurveyFooter"></app-footer>
      </div>
    </div>
    <div *ngIf="maxPageNumber > 0 && !isOfflinePage" role="navigation" class="navigation-band">
      <div
        class="mobile-progress-bar"
        *ngIf="
          maxPageNumber > 1 &&
          getDisplayPageCount(pageNumber) > 1 &&
          (surveyData?.SurveyDetails.isProgress == 1 ||
            surveyData?.SurveyDetails.isProgress == 2 ||
            surveyData?.SurveyDetails.isProgress == 3) &&
          isMobile
        "
      >
        <app-progressbar [PercentValue]="GetPercentage()"></app-progressbar>
      </div>
      <div
        *ngIf="maxPageNumber > 0"
        [ngStyle]="defaultBtnAlignWidth()"
        [style.justify-content]="
          surveyData?.SurveyDetails.isNextBtnText && !surveyData?.SurveyDetails.isNextBtnCenter
            ? 'flex-end'
            : !surveyData?.SurveyDetails.isNextBtnText || surveyData?.SurveyDetails.isNextBtnCenter
              ? 'center'
              : 'initial'
        "
        [ngClass]="{
          'full-survey-width-footer':
            (surveyData?.SurveySettings.surveyWidthType === 3 || isTablet) && !isMobile,
          'medium-survey-width-footer':
            surveyData?.SurveySettings.surveyWidthType === 2 && !isTablet && !isMobile,
          'small-survey-width-footer':
            surveyData?.SurveySettings.surveyWidthType === 1 && !isTablet && !isMobile,
          noBackBtnShow: pageNumber === 0,
          BackBtnVisible: pageNumber !== 0,
          isclearanswers: !isMobile && surveyData?.SurveySettings.isclearanswers,
          isSaveLateAnswer: !isMobile && surveyData?.SurveySettings.IsEditLater,
          isBothBtnEnable:
            surveyData?.SurveySettings.isclearanswers && surveyData?.SurveySettings.IsEditLater,
          'btn-type-text': this.surveyData.SurveyDetails.ButtonType === 0,
          'btn-type-icon': this.surveyData.SurveyDetails.ButtonType === 1,
          'btn-type-iconText': this.surveyData.SurveyDetails.ButtonType === 2,
          'btn-style-outline': this.surveyData.SurveyDetails.ButtonStyle,
          'btn-style-filled': !this.surveyData.SurveyDetails.ButtonStyle,
          'btn-size-sm': this.surveyData.SurveyDetails.ButtonSize === 0,
          'btn-size-md': this.surveyData.SurveyDetails.ButtonSize === 1,
          'btn-size-lg': this.surveyData.SurveyDetails.ButtonSize === 2,
          'btn-position-leftRightEnd': this.surveyData.SurveyDetails.Position === 0,
          'btn-position-center': this.surveyData.SurveyDetails.Position === 1,
          'btn-position-left': this.surveyData.SurveyDetails.Position === 2,
          'btn-back-small': this.surveyData.SurveyDetails.IsBackButtonSmaller,
          isCustomBtnTextEnable: this.surveyData.SurveyDetails.isNextBtnText,
          'btn-back-icon': this.surveyData.SurveyDetails.IsBackButtonIcon,
          'btn-position-right': this.surveyData.SurveyDetails.Position === 3,
          'next-btn-center': surveyData?.SurveyDetails.isNextBtnCenter,
          'btn-submit-avaible':
            pageNumber === maxPageNumber - 1 || isEndSurveyOnPage || isAllQuestionHideOnNextPages,
          isBtnisSingle:
            !isMobile &&
            !surveyData?.SurveySettings.isclearanswers &&
            !surveyData?.SurveySettings.IsEditLater &&
            pageNumber === 0,
          'single-page-submit':
            maxPageNumber === 1 ||
            (pageNumber > 0 &&
              !(pageNumber < maxPageNumber - 1) &&
              isAllQuestionHideOnPrevPages &&
              !surveyData?.SurveySettings.isShowBack) ||
            (pageNumber === 0 && surveyData?.SurveyDetails.isNextBtnCenter) ||
            (isAllQuestionHideOnNextPagesPreview && pageNumber === 0) ||
            (isAllQuestionHideOnPrevPages && pageNumber === maxPageNumber - 1) ||
            (isAllQuestionHideOnPrevPages &&
              (isAllQuestionHideOnNextPages || isAllQuestionHideOnNextPagesPreview) &&
              pageNumber > 0 &&
              pageNumber < maxPageNumber - 1)
        }"
        class="tblPageFooter footerBtnSyled"
        #targetElement
      >
        <div
          class="navigation-btns-wrapper btn-align-mar back-button-wrap"
          [ngStyle]="{
            'pointer-events':
              pageNumber > 0 &&
              !isAllQuestionHideOnPrevPages &&
              surveyData?.SurveySettings.isShowBack
                ? 'all'
                : 'none'
          }"
        >
          <ng-container
            *ngIf="
              pageNumber > 0 &&
              !isAllQuestionHideOnPrevPages &&
              surveyData?.SurveySettings.isShowBack
            "
          >
            <button
              type="button"
              class="back-button"
              (click)="GetBackPage()"
              [disabled]="this.preview.isPagePreview"
              [ngClass]="{
                'page-preview': this.preview.isPagePreview,
                'btn-shape-curved': surveyData?.SurveyDetails.Shape == 0,
                'btn-shape-rounded': surveyData?.SurveyDetails.Shape == 1,
                'btn-shape-square': surveyData?.SurveyDetails.Shape == 2
              }"
              [attr.aria-label]="surveyData.SurveyMessages.back"
              [attr.aria-hidden]="
                pageNumber > 0 &&
                !isAllQuestionHideOnPrevPages &&
                surveyData?.SurveySettings.isShowBack
                  ? false
                  : true
              "
            >
              <!-- Back -->
              <span class="footer-btn-text" *ngIf="!isMobile">{{
                surveyData?.SurveyMessages.back
              }}</span>
              <ng-container *ngIf="isMobile">
                <span class="btn-next-mob">
                  <span class="back-btn-icon"></span>
                </span>
              </ng-container>
            </button>
          </ng-container>
        </div>

        <div
          *ngIf="isMobile"
          class="clsPageNo"
          [ngClass]="getDisplayPageCount(pageNumber) == 1 ? 'SingleclsPageNO' : ''"
          [ngStyle]="{
            visibility:
              surveyData?.SurveySettings.displaypagenumber &&
              getDisplayPageCount(pageNumber) > 1 &&
              isMobile
                ? 'visible'
                : 'hidden'
          }"
        ></div>

        <ng-container
          *ngIf="
            (surveyData?.SurveySettings.isclearanswers || surveyData?.SurveySettings.IsEditLater) &&
              this.surveyData.SurveyDetails.Position !== 1;
            else clearAnswerOption
          "
        >
          <div class="btnClearLaterMain">
            <ng-container *ngTemplateOutlet="clearAnswerOption"></ng-container>
          </div>
        </ng-container>

        <ng-template #clearAnswerOption>
          <div
            *ngIf="!isMobile && surveyData?.SurveySettings.isclearanswers"
            class="navigation-btns-wrapper clear-answers-button-wrap clear-answer-option"
            [ngStyle]="{
              'text-align': selectedLang == 1 ? 'left' : 'right',
              'pointer-events': this.preview.isPagePreview ? 'none' : 'all',
              display:
                !isMobile && surveyData?.SurveySettings.isclearanswers ? 'inline-block' : 'none'
            }"
          >
            <div
              class="btn_inner_div"
              [ngStyle]="{
                'text-align':
                  surveyData.SurveySettings.IsEditLater && !this.isOfflineSurvey
                    ? 'inherit'
                    : 'center'
              }"
            >
              <a href="javascript:void(0);" (click)="ResetPage1(pageNumber)" class="footer-txt-clr">
                <!-- Clear answers on page -->
                {{ surveyData?.SurveyMessages.ClearAllAnswers }}
              </a>
            </div>
          </div>
          <div
            *ngIf="!isMobile && surveyData?.SurveySettings.IsEditLater && !this.isOfflineSurvey"
            class="navigation-btns-wrapper clear-answers-button-wrap save-answer-option"
            [ngStyle]="{ 'text-align': selectedLang == 1 ? 'right' : 'left' }"
          >
            <div
              class="btn_inner_div"
              [ngStyle]="{
                'text-align': surveyData.SurveySettings.isclearanswers ? 'inherit' : 'center'
              }"
            >
              <a
                href="javascript:void(0);"
                [ngClass]="{ disabled: isSaveAndContinueDisabled }"
                class="footer-txt-sav"
                [ngClass]="this.preview.isPagePreview ? 'page-preview' : ''"
              >
                <!-- Save and Continue Later -->
                <span (click)="SaveAndContinue(pageNumber)">{{
                  surveyData?.SurveyMessages.SaveContinueLater
                }}</span>
                               <div
                  class="saveandcontinue"
                  role="button"
                  tabindex="0"
                  (mouseenter)="showTooltipClass()"
                  (mouseleave)="hideTooltipClass()"
                  (focus)="showTooltip()"
                  (blur)="hideTooltip()"
                  aria-label="Save and Continue"
                  aria-describedby="saveandcontinue-tooltip"
                >
                  <div id="saveandcontinue-tooltip" class="ic-tooltip-wrapper" role="tooltip">
                    <div class="ic-tooltip-header">
                      {{ surveyData?.SurveyMessages.SaveContinueLater }}
                    </div>
                    <div
                      class="ic-tooltip-info"
                      style="white-space: normal"
                      [innerHTML]="surveyData?.SurveyMessages.StrSaveHelp | headerFooterHtml"
                    ></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </ng-template>

        <div
          *ngIf="
            pageNumber < maxPageNumber - 1 && !isEndSurveyOnPage && !isAllQuestionHideOnNextPages
          "
          class="navigation-btns-wrapper btn-align-mar"
          [ngClass]="{
            'next-button-wrap': !(surveyData?.SurveyDetails.isNextBtnCenter && pageNumber == 0)
          }"
        >
          <button
            type="submit"
            class="next-button"
            [disabled]="this.preview.isPagePreview"
            [ngClass]="{
              'page-preview': this.preview.isPagePreview,
              'btn-shape-curved': surveyData?.SurveyDetails.Shape == 0,
              'btn-shape-rounded': surveyData?.SurveyDetails.Shape == 1,
              'btn-shape-square': surveyData?.SurveyDetails.Shape == 2
            }"
            [attr.aria-label]="surveyData.SurveyMessages.next"
          >
            <!-- Next -->
            <span
              class="footer-btn-text"
              *ngIf="
                !isMobile &&
                ((!surveyData?.SurveyDetails.isNextBtnText && pageNumber == 0) || pageNumber > 0)
              "
              >{{ surveyData?.SurveyMessages.next }}</span
            >
            <span
              class="footer-btn-text"
              *ngIf="!isMobile && surveyData?.SurveyDetails.isNextBtnText && pageNumber == 0"
              >{{ surveyData?.SurveyMessages.NextBtnText }}</span
            >
            <ng-container *ngIf="isMobile">
              <span class="btn-next-mob">
                <span class="next-btn-icon"></span>
              </span>
            </ng-container>
          </button>
        </div>

        <div
          *ngIf="
            pageNumber == maxPageNumber - 1 || isEndSurveyOnPage || isAllQuestionHideOnNextPages
          "
          class="navigation-btns-wrapper btn-align-mar submit-btn-wrap"
          [ngClass]="isMobile ? 'submit-btn-mobile-wrap' : ''"
        >
          <button
            type="submit"
            class="submit-button"
            [disabled]="formValisandSubmited || this.preview.isPagePreview"
            [ngClass]="{
              'page-preview': this.preview.isPagePreview,
              'btn-shape-curved': surveyData?.SurveyDetails.Shape == 0,
              'btn-shape-rounded': surveyData?.SurveyDetails.Shape == 1,
              'btn-shape-square': surveyData?.SurveyDetails.Shape == 2
            }"
            [attr.aria-label]="surveyData.SurveyMessages.submit"
          >
            <!-- Submit -->
            <span
              *ngIf="
                this.surveyData.SurveyDetails.ButtonType === 1 ||
                this.surveyData.SurveyDetails.ButtonType === 2
              "
              class="submit-button-icon-text"
            ></span>
            <span [ngClass]="!isMobile ? 'footer-btn-text' : ''" *ngIf="!isMobile">{{
              surveyData?.SurveyMessages.submit
            }}</span>
            <!-- PRT 102385 -->
            <ng-container *ngIf="this.surveyData.SurveyDetails.ButtonType !== 1">
              <span *ngIf="isMobile"> {{ surveyData?.SurveyMessages.submit }}</span>
            </ng-container>

            <!-- PRT 102385 -->
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="isOfflinePage">
      <app-offline
        (SurveyResponseUpdate)="SurveyResponseUpdate()"
        (Startsurvey1)="Startsurvey()"
        (GetData)="GetData()"
      ></app-offline>
    </div>

    <div
      *ngIf="
        isMobile &&
        surveyData?.SurveySettings.displaypagenumber &&
        getDisplayPageCount(pageNumber) > 1
      "
      class="clsPageNo new-position"
      [ngClass]="getDisplayPageCount(pageNumber) == 1 ? 'SingleclsPageNO' : ''"
    >
      <span
        [attr.aria-label]="
          surveyData?.SurveyMessages.page +
          ' ' +
          getDisplayPageNo(pageNumber) +
          ' ' +
          surveyData?.SurveyMessages.of1 +
          ' ' +
          getDisplayPageCount(pageNumber)
        "
      >
        {{ surveyData?.SurveyMessages.page }} {{ getDisplayPageNo(pageNumber) }}
        {{ surveyData?.SurveyMessages.of1 }} {{ getDisplayPageCount(pageNumber) }}
      </span>
    </div>

    <div
      *ngIf="
        surveyData?.CorpSettings.GDPROption > 0 &&
        !isThankYouPage &&
        !isSaveAndContinue &&
        !this.isOfflineSurvey
      "
      class="data-policy-body clsTimeOutMsg"
    >
      <span
        (click)="ShowGDPR(true)"
        class="data-policy-link"
        tabindex="0"
        [attr.aria-label]="surveyData.CorpSettings.GPDRDataHeader"
        role="link"
        (keydown)="ShowGDPRKeyboard($event)"
        >{{ surveyData.CorpSettings.GPDRDataHeader }}</span
      >
      <app-gdpr
        [Header]="surveyData.CorpSettings.GPDRDataHeader"
        [GDPRData]="surveyData.GDPRData"
        *ngIf="showGDPR"
        (showGDPR)="ShowGDPR($event)"
      ></app-gdpr>
    </div>

    <div
      *ngIf="surveyData?.SurveySettings.IsAnonymous && !isMobile"
      class="anonymous-survey-wrapper"
    >
      <div
        class="anonymous-survey"
        (click)="ShowAnonymous(true)"
        (keydown)="ShowAnonymousKeydown($event)"
        tabindex="0"
        role="button"
      >
        <!-- Anonymous Survey -->
        <span [innerHTML]="surveyData?.SurveyMessages.AnonymousHdr | headerFooterHtml"></span>
      </div>
      <app-anonymous
        [IsSemiAnonymous]="surveyData.SurveySettings.IsSemiAnonymous"
        [Header]="surveyData.SurveyMessages.AnonymousMessageHeader"
        [Message]="surveyData.SurveyMessages.AnonymousMessage"
        *ngIf="showAnonymous"
        (showAnonymous)="ShowAnonymous($event)"
      ></app-anonymous>
    </div>
    <div
      class="progress-bar-wrapper progress-bar-wrapper-footer"
      *ngIf="
        maxPageNumber > 1 &&
        getDisplayPageCount(pageNumber) > 1 &&
        (surveyData?.SurveyDetails.isProgress == 1 ||
          surveyData?.SurveyDetails.isProgress == 4 ||
          surveyData?.SurveyDetails.isProgress == 3) &&
        !isMobile &&
        !isOfflinePage
      "
    >
      <app-progressbar
        *ngIf="surveyData?.SurveyDetails.isProgress != 4"
        [PercentValue]="GetPercentage()"
      ></app-progressbar>
      <div
        class="clsPageNo"
        *ngIf="surveyData?.SurveySettings.displaypagenumber && getDisplayPageCount(pageNumber) > 1"
      >
        <span>
          <!-- Page {{pageNumber + 1}} of {{maxPageNumber}} -->
          {{ surveyData?.SurveyMessages.page }} {{ getDisplayPageNo(pageNumber) }}
          {{ surveyData?.SurveyMessages.of1 }} {{ getDisplayPageCount(pageNumber) }}
        </span>
      </div>
    </div>

    <div
      *ngIf="surveyData?.SurveyDetails.isShowTimeOut && !isMobile"
      class="timeout-msg clsTimeOutMsg"
    >
      {{ surveyData?.SurveyMessages.SurveyTimeOutMessage }}
    </div>

    <div style="height: 32px" *ngIf="!surveyData?.CorpSettings.isPoweredByClient"></div>
    <div
      class="footer-div"
      [ngClass]="{ 'main-footer-div': !surveyData.CorpSettings.isPoweredByClient }"
      [ngStyle]="{
        'box-shadow': surveyData?.CorpSettings.isPoweredByClient ? 'none' : '',
        'background-color': surveyData?.CorpSettings.isPoweredByClient ? 'transparent' : ''
      }"
      *ngIf="
        !surveyData?.CorpSettings.isPoweredByClient ||
        (surveyData?.SurveyDetails.isShowTimeOut && !isMobile) ||
        (maxPageNumber > 1 &&
          getDisplayPageCount(pageNumber) > 1 &&
          (surveyData?.SurveyDetails.isProgress == 1 ||
            surveyData?.SurveyDetails.isProgress == 4 ||
            surveyData?.SurveyDetails.isProgress == 3) &&
          !isMobile &&
          !isOfflinePage) ||
        (surveyData?.SurveySettings.IsAnonymous && !isMobile) ||
        (surveyData?.CorpSettings.GDPROption > 0 &&
          !isThankYouPage &&
          !isSaveAndContinue &&
          !this.isOfflineSurvey)
      "
    >
      <div
        *ngIf="!surveyData?.CorpSettings.isPoweredByClient"
        [innerHTML]="surveyData?.CorpSettings.PoweredByText | headerFooterHtml"
      ></div>
    </div>
    <div
      *ngIf="isNewParticipation && surveyFormat == 2"
      [ngStyle]="{ height: headerFooterSpacer() ? '300px' : '' }"
      class="footer-spacer"
    ></div>
  </div>

  <div *ngIf="isThankYouPage" id="thankyou-section-wrapper">
    <app-thank-you-message
      [surveyData]="surveyData"
      [ThankYouMessage]="
        surveySpecificData.ParticipationMessages?.thankYouMessage == null ||
        surveySpecificData.ParticipationMessages?.thankYouMessage == undefined
          ? surveyData?.ParticipationMessages?.thankYouMessage
          : surveySpecificData.ParticipationMessages?.thankYouMessage
      "
      [ResponseRecorded]="surveyData.SurveyMessages?.ResponseRecorded"
      [PoweredByText]="surveyData?.CorpSettings.PoweredByText"
      [isPowredByClient]="this.surveyData.CorpSettings.isPoweredByClient"
      [isReopenResponse]="surveyData?.SurveySettings.isReopenResponse"
      [IsMobile]="isMobile"
      [IsPreview]="isPreview"
      [ToasterMessageForPreview]="toasterMessageForPreview"
      [ReopenText]="surveyData?.SurveySettings.ReopenText"
      [surveyWidthType]="surveyData?.SurveySettings.surveyWidthType"
      [isMobile]="isMobile"
      [SurveyLogoImageUrl]="surveyData?.SurveySettings.SurveyLogoImageUrl"
      [SurveyLogoAlign]="surveyData?.SurveySettings.SurveyLogoAlign"
      [isShowPartial]="surveyData?.SurveyDetails.isShowPartial"
      [RecNo]="surveyData?.ResponseInfo.ResponseUID"
      (EditResponceHandling)="EditResponceHandling($event)"
      (StartNewResponse)="StartNewResponse()"
    ></app-thank-you-message>
  </div>
  <!-- Added saveandcontinue-aligncenter for PRT 102492 -->
  <div *ngIf="isSaveAndContinue" class="msg-bg-overlay"></div>
  <div
    *ngIf="isSaveAndContinue"
    style="margin: 0 auto"
    class="SurveyMsgWrapper"
    [ngClass]="{
      'full-survey-width':
        (surveyData?.SurveySettings.surveyWidthType == 3 || isTablet) && !isMobile,
      'medium-survey-width':
        surveyData?.SurveySettings.surveyWidthType == 2 && !isTablet && !isMobile,
      'small-survey-width':
        surveyData?.SurveySettings.surveyWidthType == 1 && !isTablet && !isMobile,
      'browser-message-width':
        surveySpecificData?.Participation_Message_Type == 20 ||
        surveySpecificData?.Participation_Message_Type == 21,
      'saveandcontinue-aligncenter':
        surveySpecificData?.Participation_Message_Type != 51 &&
        surveySpecificData?.Participation_Message_Type != 20 &&
        surveySpecificData?.Participation_Message_Type != 21 &&
        !isMobile
    }"
  >
    <app-survey-messages
      [participation_Messages]="surveySpecificData?.ParticipationMessages"
      [participation_Message_Type]="surveySpecificData?.Participation_Message_Type"
      [PoweredByText]="surveyData?.CorpSettings.PoweredByText"
      [isSurveyExpired]="surveyData?.SurveyDetails?.isSurveyExpired"
      [isSubscriptionModel]="surveyData?.SurveySettings?.isSubscriptionModel"
      [isMobile]="isMobile"
      [isPreview]="surveyData?.SurveyDetails?.GroupType == 'preview' ? true : false"
      [isAssessment]="this.surveyData.SurveySettings.isAssessment"
      [ProductName]="productName"
      [SupportEmail]="this.surveyData.CorpSettings.SupportEmail"
      [isPowredByClient]="this.surveyData.CorpSettings.isPoweredByClient"
      [SurveyLogoImageUrl]="this.surveyData.SurveySettings.SurveyLogoImageUrl"
      [SurveyLogoAlign]="this.surveyData.SurveySettings.SurveyLogoAlign"
      [isTablet]="isTablet"
      [SurveyURL]="SurveyURL"
      [Title]="this.surveyData.SurveyMessages.Title"
      (partialResponceHandling)="partialResponceHandling($event)"
      (EditResponceHandling)="EditResponceHandling($event)"
    ></app-survey-messages>
  </div>
  <div
    *ngIf="!surveyData?.CorpSettings.isPoweredByClient && isSaveAndContinue"
    class="footer-div survey-messages-footer"
  >
    <div [innerHTML]="surveyData?.CorpSettings.PoweredByTextMessage | headerFooterHtml"></div>
  </div>

  <div
    *ngIf="
      surveyData?.SurveySettings.isSubscriptionModel && surveyData?.CorpSettings.account_type == 10
    "
  >
    <app-sign-up></app-sign-up>
  </div>

  <div
    *ngIf="
      (surveyData?.SurveySettings.isLaunchNow || surveyData?.SurveySettings.isLaunchNowEnabled) &&
      isFromSB == '0' &&
      surveyData?.SurveyDetails?.GroupType != 'preview'
    "
    class="survey-launch-container"
    (click)="launchSampleSurvey()"
  >
    <span class="survey-launch-container-banner"> </span
    ><span class="survey-launch-container-info">Launch Now!</span>
    <div class="survey-launch-hover-text">
      Want to launch this survey right away? Click here to get started on our platform!
    </div>
  </div>
</form>
<div class="Plat_Alert Warning Plat_Alert_custom For_Mobile" style="display: none">
  <span class="success"></span>
  <span class="spnMsg" [ngStyle]="{ 'text-align': isMobile ? 'left' : 'unset' }"
    ><span [innerHTML]="strPreviewMsg | headerFooterHtml" id="spnPreviewMsgToast"></span
  ></span>
  <div class="estimated-time-text1" [ngStyle]="{ 'text-align': isMobile ? 'left' : 'unset' }">
    Estimated completion time:
    <span
      [innerHTML]="strPreviewTime | headerFooterHtml"
      class="estimated-time"
      id="spnPreviewTimeToast"
    ></span>
  </div>
  <span class="closebtn" id="close-btn-mobile"></span>
</div>
